<div class="modal-body">
  <div class="mb-3">
    <div class="header d-flex  align-items-center">
      <div><i class="fa-solid fa-envelope mr-1" style="color: #2e93a1;"></i>
        <span class = 'modal-heading'>
          Create a campaign
        </span>
      </div>

      <div>
        <span (click)="closeModal()" class="close-btn">
          <i class="fa-regular fa-xmark" style="color: #2c2c2c;"></i>
        </span>
      </div>
    </div>
  </div>
  <div>
    <!-- Add the 'required' attribute to enforce the required validation -->
    <form #form="ngForm" (ngSubmit)="addData()" novalidate>
      <label for="campaignName" class="mb-0">Campaign name</label>
      <input data-testid="auto-app-create-campaign-modal-input-1" placeholder="Campaign name" [(ngModel)]="modalData.campaignName" name="campaignName" class='campaign-inpt w-100' minlength="4" required />
      <!-- Display a validation message if the campaignName is required and not provided -->
      <div *ngIf="form.controls['campaignName'] && form.controls.campaignName.errors?.required && form.controls.campaignName.touched" class="error-message">
        Campaign name is required.
      </div>
      <div *ngIf="duplicateCampaignNameError && duplicateCampaignNameError.length" class="error-message">
        Campaign already exists
      </div>
      <div *ngIf="form.controls['campaignName'] && form.controls.campaignName.errors?.minlength && displayError" class="error-message">
        Campaign name should be atleast 4 character long
      </div>
    </form>
  </div>
  <button data-testid="auto-app-create-campaign-modal-button-1" class="btn-trms-small d-block ml-auto mt-3" (click)="addData()">Add</button>
</div>
